package space.resolvingcode.tableNavigator

import kotlinx.browser.document
import org.w3c.dom.Element

private fun createDiv(txt: String) : Element {
    val el = document.createElement("div")
    el.append(txt)
    return el
}

const val latestVer = "0.1.1"

fun putReleaseNote() {
    document.getElementById("releaseNote")!!.run {
        append(createDiv("ver $latestVer 2024/09/17 カラーテーマ選択ボタンを追加"))
        append(createDiv("ver 0.1.0 2024/07/07 公開"))
    }
    document.getElementById("update")!!
        .append(" Released:2024/9/17")
}
